module.exports = __webpack_public_path__ + "a9dec775437c2ba9d1c33641616c3d01.svg";